var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpenSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9594 1.99597C19.9594 1.37847 19.6787 0.798404 19.1922 0.424165C18.7057 0.0499262 18.0757 -0.0872948 17.477 0.0624008L6.25603 2.86919C4.92748 3.19977 3.99188 4.39734 3.99188 5.76955V27.9432H1.99594C0.891936 27.9432 0 28.8351 0 29.9391C0 31.0431 0.891936 31.9351 1.99594 31.9351H5.98782H17.9635H19.9594V29.9391V1.99597ZM15.9675 15.9676C15.9675 17.0716 15.3001 17.9635 14.4706 17.9635C13.641 17.9635 12.9736 17.0716 12.9736 15.9676C12.9736 14.8636 13.641 13.9716 14.4706 13.9716C15.3001 13.9716 15.9675 14.8636 15.9675 15.9676ZM21.9554 7.98379H27.9432V29.9391C27.9432 31.0431 28.8351 31.9351 29.9391 31.9351H33.931C35.035 31.9351 35.9269 31.0431 35.9269 29.9391C35.9269 28.8351 35.035 27.9432 33.931 27.9432H31.9351V7.98379C31.9351 5.78202 30.1449 3.99191 27.9432 3.99191H21.9554V7.98379Z",
    fill: "#CC7480"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9269,
    height: 31.9351,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenSolid);
export default __webpack_public_path__ + "static/media/door-open-solid.99a74d6949fd4d6dda3ed092eea063e7.svg";
export { ForwardRef as ReactComponent };